import React from 'react';

const CITY_URL = 'https://cloud.paysend.com/images/web/bg-color-cities';

export default function Illustration({ countryToCode, promoSendHeadline }) {
    return (
        <div className="section-image no-spinner" id="section-image">
            <div className="section-image">
                <figure className="illustration">
                    <picture id="picture-country">
                        <source
                            data-size="d"
                            media="(min-width: 1440px)"
                            srcSet={`${CITY_URL}/${countryToCode}-d.jpg 1x, ${CITY_URL}/${countryToCode}-d@2x.jpg 2x`}
                        />
                        <source
                            data-size="c"
                            media="(min-width: 1040px)"
                            srcSet={`${CITY_URL}/${countryToCode}-c.jpg 1x, ${CITY_URL}/${countryToCode}-c@2x.jpg 2x`}
                        />
                        <source
                            data-size="b"
                            media="(min-width: 656px)"
                            srcSet={`${CITY_URL}/${countryToCode}-b.jpg 1x, ${CITY_URL}/${countryToCode}-b@2x.jpg 2x`}
                        />
                        <source data-size="a" srcSet={`${CITY_URL}/${countryToCode}-a.jpg 1x, ${CITY_URL}/${countryToCode}-a@2x.jpg 2x`} />
                        <img alt={promoSendHeadline} src={`${CITY_URL}/${countryToCode}-c.jpg`} />
                    </picture>
                </figure>
            </div>
        </div>
    );
}
